<template>
  <v-container fluid class="pa-0 pa-sm-3">
   <!--
   <div class="todo-notifications">
     //TODO ilmoituset taulukko
   </div>
   -->
   <!-- <resource-calendar /> -->
    <planned-service-events v-if="$featurePermissions.plannedServiceCRUD"/>
  </v-container>
</template>

<script>
import Vue from 'vue';
import PlannedServiceEvents from '@/views/frontpage/planned-service-events-table/PlannedServiceEvents';
//import ResourceCalendar from '@/views/frontpage/resourceCalendar/ResourceCalendar';

export default Vue.extend({
  components: {  PlannedServiceEvents },
  name: 'Frontpage',
  data() {
    return {
    };
  },
});
</script>
<style>
.todo-notifications{
  height: 10em; background-color:lightgray; width: 60%; margin-bottom: 2em;
}

</style>
